module.exports = __webpack_public_path__ + "img/logo_1.8d446527.png";